import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllStaffs.graphql';
import { Query, QueryallStaffsArgs } from '../../__generated__/globalTypes';

export const useAllStaffsQuery = (options?: QueryHookOptions<Query, QueryallStaffsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallStaffsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllStaffsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallStaffsArgs>
): QueryResult<Query, QueryallStaffsArgs> & { getAllStaffs: LazyQueryExecFunction<Query, QueryallStaffsArgs> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllStaffs, result] = useLazyQuery<Query, QueryallStaffsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllStaffs, ...result };
};

export const useAllStaffsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllStaffs = useCallback(
    (options?: Omit<QueryOptions<QueryallStaffsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallStaffsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllStaffs };
};
// Suspense Query Hooks
export const useAllStaffsSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QueryallStaffsArgs>) => {
  const result = useSuspenseQuery<Query, QueryallStaffsArgs>(QUERY, {
    ...options
  });

  return result;
};
